import { render, staticRenderFns } from "./widget-layout.vue?vue&type=template&id=54e137be&scoped=true&"
import script from "./widget-layout.vue?vue&type=script&lang=js&"
export * from "./widget-layout.vue?vue&type=script&lang=js&"
import style0 from "./widget-layout.vue?vue&type=style&index=0&id=54e137be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e137be",
  null
  
)

export default component.exports